export default function (instance) {
    return {
        getUser(payload){
            return instance.get('user', payload)
        },
        createUser(payload){
            return instance.postForm('user', payload)
        },
        optionsClub(payload){
            return instance.options('club', payload)
        },
        changeCurrentClub(id){
            return instance.postForm('user/current-club', {club: id})
        },
        updateUser(payload) {
            const params = new URLSearchParams()
            Object.entries(payload).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    params.append(key, value)
                }
            })
            return instance.put('user', params, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
        },
    }
}